.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1440px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}
